import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { jwtDecode } from 'jwt-decode';
function getCookie(name, cookieString = document.cookie) {
    if (!cookieString)
        return null;
    const nameEQ = name + '=';
    for (const part of cookieString.split(';')) {
        const c = part.trim();
        if (c.startsWith(nameEQ)) {
            try {
                return decodeURIComponent(c.slice(nameEQ.length));
            }
            catch (_a) {
                return c.slice(nameEQ.length);
            }
        }
    }
    return null;
}
export const JWT = () => {
    var _a;
    const auth = getCookie('auth');
    if (auth === null) {
        return _jsx("div", { children: "No auth cookie" });
    }
    const decodedHeader = jwtDecode(auth, { header: true });
    const decodedPayload = jwtDecode(auth, { header: false });
    const iat = new Date(1000 * ((_a = decodedPayload.iat) !== null && _a !== void 0 ? _a : 0));
    return (_jsxs("div", { style: { padding: '20px' }, children: [_jsx("pre", { children: JSON.stringify(decodedHeader) }), _jsx("pre", { children: JSON.stringify(decodedPayload) }), _jsxs("div", { children: ["IAT: ", iat.toLocaleString()] })] }));
};
